import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

interface LogoProps {
    className?: string
    tone?: 'default' | 'inverted'
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            aria-hidden='true'
            className={cn('size-7 shrink-0', className)}
        >
            <path d='M16 3 28.5 9.75 16 16.5 3.5 9.75Z' fill='#a6ada9' />
            <path d='M3.5 9.75 16 16.5v13L3.5 22.75Z' fill='#2f3a37' />
            <path d='M28.5 9.75 16 16.5v13l12.5-6.75Z' fill='#56615d' />
            <circle
                cx='16'
                cy='9.75'
                r='2.7'
                fill='#0b6b4f'
                stroke='#f5f4ef'
                strokeWidth='1.2'
            />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, tone = 'default' }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark />

            <span
                className={cn(
                    'text-[0.8rem] font-semibold uppercase tracking-[0.24em]',
                    tone === 'inverted' ? 'text-ink-foreground' : 'text-foreground'
                )}
            >
                ConcreTrack
            </span>
        </span>
    )
}
